import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
const EVENT_API = "http://notregrandbleu.herokuapp.com/";
const EMAIL_API = "http://notregrandbleu.herokuapp.com/mail/";
const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" })
};
@Injectable({
  providedIn: 'root'
})
export class EventService {

 constructor(private http: HttpClient) { }

  public AfficherEvent(): Observable<any> {
    return this.http.get(EVENT_API , httpOptions);
  }
  addEvent(event): Observable<any> {
    return this.http.post(EVENT_API + "addEvent", event ,httpOptions );
  }
  delete(id): Observable<any> {
    return this.http.get(EVENT_API + "deleteEvent/"+ id ,httpOptions );
  }
  addEmail(mail): Observable<any> {
    return this.http.post(EMAIL_API + "addemail", mail ,httpOptions );
  }
  public AfficherEmails(): Observable<any> {
    return this.http.get(EMAIL_API , httpOptions);
  }
  deleteNewLater(id): Observable<any> {
    return this.http.get(EMAIL_API + "deleteNewsLater/"+ id ,httpOptions );
  }
  getById(id): Observable<any> {
    return this.http.get(EVENT_API + "search/"+ id ,httpOptions );
  }
}
